<div *ngIf="reservation" class="ticket-container group">
  <!-- Ticket Body -->
  <div class="ticket-content">
    
    <!-- LEFT: Date & Status -->
    <div class="ticket-left">
      <div class="date-display">
        <span class="day">{{ reservation.createdAt | date:'dd' }}</span>
        <span class="month">{{ reservation.createdAt | date:'MMM' | uppercase }}</span>
      </div>
      <div class="status-badge" [ngClass]="{'status-confirmed': reservation.statusId === 2, 'status-pending': reservation.statusId === 1}">
        {{ reservation.statusId === 2 ? ('reservationCard.confirmed' | translate) : ('reservationCard.pending' | translate) }}
      </div>
    </div>

    <!-- CENTER: Info -->
    <div class="ticket-center">
      <div class="ticket-info">
        <h3 class="event-title">
            {{ 'reservationCard.reservation' | translate }} {{reservation.locator}}
        </h3>
        <div class="ticket-details">
            <span class="detail-item">
                 {{ reservation.items.length }} {{ reservation.items.length === 1 ? ('reservationCard.item' | translate) : ('reservationCard.items' | translate) }}
            </span>
             <span class="detail-item">
                <fa-icon [icon]="faCreditCardAlt"></fa-icon> 
                {{ reservation.total | currency }}
            </span>
        </div>
      </div>
    </div>

    <!-- RIGHT: Actions -->
    <div class="ticket-right">
       <div class="cutout-top"></div>
       <div class="cutout-bottom"></div>
       
       <button class="action-btn" (click)="goToReservation(reservation)">
            <span class="btn-text">{{ 'reservationCard.viewTicket' | translate }}</span>
            <fa-icon [icon]="faArrowRight"></fa-icon>
       </button>
    </div>

  </div>
</div>
